<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">

              <div class="row">
                <div class="form-group col-sm-12">
                  <ul class="navbar-nav overflow-auto flex-row gap-4" >
                    <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap">
                      <a href="#" @click.prevent="selectTab(value)" class="nav-link tab" :class="{'active': activeTabName === value}">{{ helper.trans(`labels.${value}`) }}</a>
                    </li>

                  </ul>
                </div>
              </div>

              <div v-if="activeTabName === Tabs.traders" class="row mt-2">
                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="traderStatuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(AntiFraudAlertStatus)"
                                   :custom-label="(opt) => helper.trans(`antifraudalerts.status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => receiptVerification()" class="btn btn-outline-dark btn-sm rounded-pill me-4 text-capitalize-first">{{ helper.trans('labels.receipt_verification') }}</button>
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>

              <div v-if="activeTabName === Tabs.merchants" class="row mt-2">
                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="merchantBanStatus"
                                   class="multiselect-sm"
                                   v-model="merchantBanRequestDTO.status"
                                   :options="merchantBanStatusOptions"
                                   :custom-label="(opt) => helper.trans(`labels.${opt}`)"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="merchantBanFilter"
                                   class="multiselect-sm"
                                   v-model="merchantBanFilter"
                                   :options="merchants"
                                   :custom-label="(opt) => `${opt.name} (${opt.email})`"
                                   :custom-value="(opt) => opt.id"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.merchant')"
                                   :searchable="true"
                                   :internal-search="true"
                                   :clear-on-select="false"
                                   :close-on-select="true"
                                   :options-limit="100"
                                   :limit="1000"
                                   :show-no-results="false"
                                   :hide-selected="false"
                                   @search-change="asyncFindMerchants"
                                   :loading="isMerchantsSelectLoading"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyMerchantBanFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearMerchantBanFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table v-if="activeTabName === Tabs.traders" class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.date') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.rule') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.trader') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.status') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.reviewed') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in response.items" :key="item.id" class="">
                    <td>{{ item.id }}</td>
                    <td>{{ dateHelper.format(item.createdAt) }}</td>
                    <td>
                      <TgUserChangeRuleDescription v-if="item.rule === AntiFraudAlertRule.tg_user_change_rule" :alert="item"></TgUserChangeRuleDescription>
                      <PayInCanceledDealsCountCheckDescription v-else-if="item.rule === AntiFraudAlertRule.pay_in_canceled_deals_count_check" :alert="item"></PayInCanceledDealsCountCheckDescription>
                      <UZSPayInCanceledDealsCountCheckDescription v-else-if="item.rule === AntiFraudAlertRule.uzs_pay_in_canceled_deals_count_check" :alert="item"></UZSPayInCanceledDealsCountCheckDescription>
                      <PayInCanceledDealsCheckDescription v-else-if="item.rule === AntiFraudAlertRule.pay_in_canceled_deals_check" :alert="item"></PayInCanceledDealsCheckDescription>
                      <PayOutCompletedDealsCheckDescription v-else-if="item.rule === AntiFraudAlertRule.pay_out_completed_deals_check" :alert="item"></PayOutCompletedDealsCheckDescription>
                      <PayOutReceiptVerificationDescription v-else-if="item.rule === AntiFraudAlertRule.pay_out_receipt_verification_rule" :alert="item"></PayOutReceiptVerificationDescription>
                      <RequisitesDeviceChangeCheckDescription v-else-if="item.rule === AntiFraudAlertRule.requisite_device_change_rule" :alert="item"></RequisitesDeviceChangeCheckDescription>
                      <ActiveDisputesCountCheckDescription v-else-if="item.rule === AntiFraudAlertRule.active_disputes_count_check" :alert="item"></ActiveDisputesCountCheckDescription>
                      <PayOutStopScamReceiptCheckDescription v-else-if="item.rule === AntiFraudAlertRule.pay_out_stopscam_receipt_check" :alert="item"></PayOutStopScamReceiptCheckDescription>
                      <span v-else>
                        {{ helper.trans(`antifraudalerts.rule.${item.rule}`) }}
                      </span>
                    </td>
                    <td>
                      <UserNameLabel v-if="item.trader" :user="item.trader"></UserNameLabel>
                    </td>
                    <td>{{ helper.trans(`antifraudalerts.status.${item.status}`) }}</td>
                    <td>
                      <div v-if="item.reviewedBy">
                        <UserNameLabel  show-badge :user="item.reviewedBy"></UserNameLabel>
                        <small class="text-secondary">{{ dateHelper.format(item.reviewedAt) }}</small>
                      </div>
                      <div class="" v-else>
                        <button v-if="item.status === AntiFraudAlertStatus.NEW" type="button" @click="markAsReviewed(item)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize">
                          <i class="fa fa-check"></i> {{helper.trans('labels.reviewed')}}
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <table v-if="activeTabName === Tabs.merchants" class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.user') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.store') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.merchant') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.status') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.ban_date') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.expires_at') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.actions') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in merchantBanResponse.items" :key="item.id" class="">
                    <td>{{ item.id }}</td>
                    <td>{{ item.userId }}</td>
                    <td>{{ item.storeName }}</td>
                    <td>{{ item.merchantName }}</td>
                    <td>
                      <span :class="getMerchantBanStatusClass(item.status)">
                        {{ helper.trans(`labels.${item.status}`) }}
                      </span>
                    </td>
                    <td>{{ dateHelper.format(item.bannedAt) }}</td>
                    <td>{{ item.expiresAt == null ? helper.trans('labels.permanent') : dateHelper.format(item.expiresAt) }}</td>
                    <td>
                      <button v-if="item.isActive && !item.isExpired" 
                              type="button" 
                              @click="unbanMerchantUser(item)" 
                              class="btn btn-sm btn-outline-danger text-nowrap text-capitalize">
                        <i class="fa fa-unlock"></i> {{ helper.trans('labels.unban_user') }}
                      </button>
                      <span v-else class="text-muted">
                        {{ item.isExpired ? helper.trans('labels.expired') : helper.trans('labels.unbanned') }}
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="activeTabName === Tabs.traders && response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

                <b-pagination
                  v-if="activeTabName === Tabs.merchants && merchantBanResponse.totalCount > merchantBanResponse.items.length"
                  v-model="merchantBanPage"
                  :total-rows="merchantBanResponse.totalCount"
                  :per-page="merchantBanResponse.limit"
                  :limit="20"
                  @update:modelValue="loadMerchantBans()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <ReceiptVerificationModal ref="receiptVerificationModal"></ReceiptVerificationModal>

  </LoaderWrapper>
</template>

<style scoped>
.nav-item-spaced {
  margin-right: 0.5rem;
}

</style>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {UserRole} from "@/models/enum/UserRole";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import {Dictionary} from "@/types";
import PaginationDTO from "@/models/PaginationDTO";
import TraderDTO from "@/models/TraderDTO";
import UserDTO from "@/models/UserDTO";
import {AntiFraudAlertStatus} from "@/models/enum/AntiFraudAlertStatus";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import Multiselect from "vue-multiselect";
import PayInCanceledDealsCheckDescription from "@/components/AntiFraud/PayInCanceledDealsCheckDescription.vue";
import {AntiFraudAlertRule} from "@/models/enum/AntiFraudAlertRule";
import PayOutReceiptVerificationDescription from "@/components/AntiFraud/PayOutReceiptVerificationDescription.vue";
import PayOutCompletedDealsCheckDescription from "@/components/AntiFraud/PayOutCompletedDealsCheckDescription.vue";
import ReceiptVerificationModal from "@/components/ReceiptVerificationModal.vue";
import PayInCanceledDealsCountCheckDescription
  from "@/components/AntiFraud/PayInCanceledDealsCountCheckDescription.vue";
import TgUserChangeRuleDescription from "@/components/AntiFraud/TgUserChangeRuleDescription.vue";
import RequisitesDeviceChangeCheckDescription from "@/components/AntiFraud/RequisitesDeviceChangeCheckDescription.vue";
import ActiveDisputesCountCheckDescription from "@/components/AntiFraud/ActiveDisputesCountCheckDescription.vue";
import PayOutStopScamReceiptCheckDescription from "@/components/AntiFraud/PayOutStopScamReceiptCheckDescription.vue";
import MerchantDTO from "@/models/MerchantDTO";
import AntiFraudMerchantBanDTO from "@/models/AntiFraudMerchantBanDTO";
import UZSPayInCanceledDealsCountCheckDescription
  from "@/components/AntiFraud/UZSPayInCanceledDealsCountCheckDescription.vue";

const api = new APIClient();
const notification = useNotification()

enum Tabs {
  traders = 'traders',
  merchants = 'merchants'
}

const defaultRequestDTO = {
  statuses: [AntiFraudAlertStatus.NEW],
  traderIds: [],
  merchantIds: []
}

const defaultMerchantBanRequestDTO = {
  status: null,
  merchantId: null as number | null
}

export default defineComponent({
  components: {
    RequisitesDeviceChangeCheckDescription,
    ActiveDisputesCountCheckDescription,
    PayOutStopScamReceiptCheckDescription,
    TgUserChangeRuleDescription,
    PayInCanceledDealsCountCheckDescription,
    ReceiptVerificationModal,
    PayOutCompletedDealsCheckDescription,
    PayOutReceiptVerificationDescription,
    PayInCanceledDealsCheckDescription,
    UZSPayInCanceledDealsCountCheckDescription,
    UserNameLabel,
    LoaderWrapper,
    CopyButton,
    BPagination,
    TraderMultiselect,
    Multiselect
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const receiptVerificationModal = ref<InstanceType<typeof ReceiptVerificationModal> | null>(null)
    const state = reactive({
      page: 1,
      merchantBanPage: 1,
      activeTabName: Tabs.traders,
      tradersFilter: [] as TraderDTO[],
      merchantsFilter: [] as MerchantDTO[],
      merchantBanFilter: null as MerchantDTO | null,
      merchants: [] as MerchantDTO[],
      isMerchantsSelectLoading: false,
      requestDTO: {...defaultRequestDTO} as any,
      merchantBanRequestDTO: {...defaultMerchantBanRequestDTO} as {status: string | null, merchantId: number | null},
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<AntiFraudAlertDTO>,
      merchantBanResponse: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<AntiFraudMerchantBanDTO>,
    });

    const selectTab = (tab: Tabs) => {
      state.activeTabName = tab;
      state.page = 1;
      state.merchantBanPage = 1;
      state.tradersFilter = [];
      state.merchantsFilter = [];
      state.merchantBanFilter = null;
      state.requestDTO = {...defaultRequestDTO};
      state.merchantBanRequestDTO = {...defaultMerchantBanRequestDTO};
      
      if (tab === Tabs.traders) {
        load();
      } else {
        loadMerchantBans();
      }
    };

    const asyncFindMerchants = async (query: string) => {
      state.isMerchantsSelectLoading = true;
      try {
        const response = await api.merchants({limit: 100, offset: 0} as PaginationDTO, {query: query});
        state.merchants = response.items;
      } finally {
        state.isMerchantsSelectLoading = false;
      }
    };

    const merchantBanStatusOptions = computed(() => ['banned', 'unbanned']);

    const getMerchantBanStatusClass = (status: string) => {
      switch (status) {
        case 'banned':
          return 'badge bg-danger';
        case 'unbanned':
          return 'badge bg-success';
        default:
          return 'badge bg-secondary';
      }
    };

    const unbanMerchantUser = async (item: AntiFraudMerchantBanDTO) => {
      loader.value?.show()
      try {
        await api.antiFraudMerchantUnban(item.id)
        notification.notify({title: helper.trans('labels.user_unbanned')});
        await loadMerchantBans();
      } catch (error) {
        notification.notify({title: helper.trans('labels.error'), type: 'error'});
      } finally {
        loader.value?.hide()
      }
    }

    const loadMerchantBans = async () => {
      loader.value?.show()
      state.merchantBanResponse.offset = state.merchantBanResponse.limit * (state.merchantBanPage - 1)
      
      if (state.merchantBanFilter) {
        state.merchantBanRequestDTO.merchantId = Number(state.merchantBanFilter.id);
      } else {
        state.merchantBanRequestDTO.merchantId = null;
      }

      try {
        state.merchantBanResponse = await api.antiFraudMerchantBans(state.merchantBanResponse, state.merchantBanRequestDTO);
      } finally {
        loader.value?.hide()
      }
    }

    const applyMerchantBanFilters = async () => {
      state.merchantBanPage = 1;
      loadMerchantBans()
    }

    const clearMerchantBanFilters = async () => {
      state.merchantBanPage = 1;
      state.merchantBanFilter = null;
      state.merchantBanRequestDTO = {...defaultMerchantBanRequestDTO}
      loadMerchantBans()
    }

    const markAsReviewed = async (item: AntiFraudAlertDTO) => {
      loader.value?.show()
      try {
        await api.antiFraudAlertsReviewed(item.id)
        await load();
      } finally {
        loader.value?.hide()
      }
    }

    const load = async () => {
      loader.value?.show()
      state.response.offset = state.response.limit * (state.page - 1)
      
      if (state.activeTabName === Tabs.traders) {
        state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
        state.requestDTO.merchantIds = []
      } else {
        state.requestDTO.merchantIds = state.merchantsFilter.map((value) => value.id)
        state.requestDTO.traderIds = []
      }

      try {
        state.response = await api.antiFraudAlerts(state.response, state.requestDTO);

        store.dispatch('afLastId', state.response.items[0]?.id ?? null)
        store.dispatch('afHasNew', false)

        let traderIds = {} as Dictionary<number>
        let userIds = {} as Dictionary<number>;
        for (const item of state.response.items) {
          traderIds[item.traderId] = item.traderId;
          if (item.reviewedByUserId) {
            userIds[item.reviewedByUserId] = item.reviewedByUserId
          }
        }

        let traders = {} as Dictionary<TraderDTO>
        for (const trader of (await api.traders({limit: Object.keys(traderIds).length, offset: 0} as PaginationDTO, {ids: Object.values(traderIds)})).items) {
          traders[trader.id] = trader
        }
        let users = {} as Dictionary<UserDTO>
        for (const user of (await api.users({limit: Object.keys(userIds).length, offset: 0} as PaginationDTO, {ids: Object.values(userIds)})).items) {
          users[user.id] = user
        }

        for (const item of state.response.items) {
          item.trader = traders[item.traderId] ?? null;
          if (item.reviewedByUserId) {
            item.reviewedBy = users[item.reviewedByUserId] ?? null;
          }
        }
      } finally {
        loader.value?.hide()
      }

    }

    const receiptVerification = async () => {
      receiptVerificationModal.value?.show()
    }

    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.tradersFilter = [];
      state.merchantsFilter = [];
      state.requestDTO = {...defaultRequestDTO}
      load()
    }

    onMounted(async () => {
      await load()
      await asyncFindMerchants('')
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      loader,
      dateHelper,
      numberFormatter,
      load,
      clearFilters,
      applyFilters,
      receiptVerification,
      receiptVerificationModal,
      helper,
      UserRole,
      markAsReviewed,
      AntiFraudAlertStatus,
      AntiFraudAlertRule,
      Tabs,
      selectTab,
      asyncFindMerchants,
      merchantBanStatusOptions,
      getMerchantBanStatusClass,
      unbanMerchantUser,
      loadMerchantBans,
      applyMerchantBanFilters,
      clearMerchantBanFilters
    }
  }
})
</script>
